// Shared quick-create customer modal used by CustomerSelect in both chip and inline modes.
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface Props {
  phone: string;
  name: string;
  onNameChange: (v: string) => void;
  customerType: string;
  onCustomerTypeChange: (v: string) => void;
  error: string;
  loading: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

export function CustomerQuickCreateModal({
  phone,
  name,
  onNameChange,
  customerType,
  onCustomerTypeChange,
  error,
  loading,
  onSubmit,
  onClose,
}: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-sm rounded-xl border bg-card p-5 shadow-xl space-y-4">
        <h3 className="font-semibold">Tạo khách hàng nhanh</h3>
        {error && <p className="text-sm text-destructive">{error}</p>}
        <div className="space-y-1">
          <label className="text-sm">SĐT</label>
          <Input value={phone} disabled className="font-mono" />
        </div>
        <div className="space-y-1">
          <label className="text-sm">Tên (tuỳ chọn)</label>
          <Input
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="Nguyễn Văn A"
            autoFocus
          />
        </div>
        <div className="space-y-1">
          <label className="text-sm">Loại khách hàng</label>
          <select
            value={customerType}
            onChange={(e) => onCustomerTypeChange(e.target.value)}
            className="w-full rounded-md border bg-background px-3 py-2 text-sm"
          >
            <option value="retail">Lẻ</option>
            <option value="wholesale">Sỉ</option>
          </select>
        </div>
        <div className="flex gap-3">
          <Button variant="outline" onClick={onClose} className="flex-1">Hủy</Button>
          <Button onClick={onSubmit} disabled={loading} className="flex-1">
            {loading ? "Đang tạo..." : "Tạo"}
          </Button>
        </div>
      </div>
    </div>
  );
}
